import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta';
import Banner from './banner/banner'
import Corporate from './corporate/corporate';
import News from './news/news';
import Case from './case/case';
import About from './about/about';
import Partner from './partners/partners';
import Footer from '../footer/footer';
import ModalUi from '../Modal/Modal';
import RightBtn from'../rightBtn/rightBtn';
import {Get} from './../../requst'
require('./home.scss')
require('../envelope/envelope.scss')

// ant css
import 'antd/dist/antd.css'

//公用样式文件
require('./../../assets/common/css/base.scss') 

import { DatePicker, Button, Checkbox,Carousel,Menu, Icon,Modal ,Tabs,Input,Alert,message} from 'antd'
const TabPane = Tabs.TabPane;
const confirm = Modal.confirm;

export default class Home extends React.Component {
    static async getInitialProps(){
        const [optimizationRes, dataRes, getQuoteRes] = await Promise.all([Get({url:'base/optimization'}), Get({url:'base/page'}), Get({url:'base/getQuote'})])

        const [footerProps,aboutProps,bannerProps,caseProps,newsProps,partnerProps] = await Promise.all([
            Footer.getInitialProps(),
            About.getInitialProps(),
            Banner.getInitialProps(),
            Case.getInitialProps(),
            News.getInitialProps(),
            Partner.getInitialProps(),
        ])

        return {
            optimization: optimizationRes.data.data,
            data: dataRes.data.data,
            getQuote: getQuoteRes.data.data, 
            footerProps,aboutProps,bannerProps,caseProps,partnerProps
        }
    }

    constructor(props, context) {
        super(props, context);
        this.CorporateCallback=this.CorporateCallback.bind(this);
        this.goConsulting=this.goConsulting.bind(this);
        // this.handleOk=this.handleOk.bind(this);
        // this.handleSubmit=this.handleSubmit.bind(this);
        // this.handleCancel=this.handleCancel.bind(this);
        this.handleScroll=this.handleScroll.bind(this);
        this.modal=this.modal.bind(this);
        // this.handleBox=this.handleBox.bind(this);
        this.handleCancelBox=this.handleCancelBox.bind(this);
        this.handelEmail=this.handelEmail.bind(this);
        // this.handleBox_one=this.handleBox_one.bind(this);
        // this.handleBox_two=this.handleBox_two.bind(this);
        // this.handleCancel_two=this.handleCancel_two.bind(this);
        // this.seversCallback=this.seversCallback.bind(this);
        // this.industryCallback=this.industryCallback.bind(this);
        this.state = {
            visible: false,
            handleBox_two:false,
            userName:'',
            userPhone:'',
            seversName:'5',
            industry:'14',
            tip:false,
            tipUser:false,

        }
       
    }
    componentDidMount() {
        const heghtHalf = window.document.body.offsetHeight/2-100;
        message.config({
        top: heghtHalf,
        duration: 1,
        maxCount: 0,
        });
        //滑动监听
        window.addEventListener('scroll', this.handleScroll);
        
    }
    CorporateCallback(){
        this.setState({visible:true})
    }
    goConsulting(){
        this.setState({
          visible: false,
        });
    }
    // handleOk(e) {
    //     // 需求提交
    //     this.Post({url:'base/putQuote',data:{phone:this.state.userPhone.toString(),name:this.state.userName,service:this.state.seversName,industry:this.state.industry,demand:this.state.demand},ContentType:'application/x-www-form-urlencoded'}).then((res)=>{
    //         console.log(res)
    //     })
    //     console.log(e);
    //     this.setState({
    //         visible: false,
    //     });
    // }
    // handleSubmit(e) {
    //     // 需求提交
    //     this.Post({url:'base/putQuote',data:{phone:this.state.userPhone.toString(),name:this.state.userName,service:this.state.seversName,industry:this.state.industry,demand:this.state.demand},ContentType:'application/x-www-form-urlencoded'}).then((res)=>{
    //         console.log(res)
    //         console.log(res.status==200)
    //         if (res.status==200) {
    //             message.success(<img style={{width:'200px',height:'280px'}} src={require('../../assets/common/images/succeed.png')} alt=""/> ,2)
    //         }
            
    //     })
    //     this.setState({
    //         visible: false,handleBox_two:false
    //     });
    // }
    // handleCancel(e){
    //     //需求提交
    //     this.Post({url:'base/putQuote',data:{phone:this.state.userPhone,name:this.state.userName,service:this.state.seversName,industry:this.state.industryName,demand:this.state.demand},ContentType:'application/x-www-form-urlencoded'}).then((res)=>{
    //         console.log(res)
    //     })
    //     console.log(e);
    //     this.setState({
    //         visible: false,
    //     });
    // }
    handleScroll(){
        let scrreenHeight =document.body.offsetHeight;
        let scrollY =window.scrollY;
        if (scrollY>=scrreenHeight) {
            this.setState({Box:true})
            window.removeEventListener('scroll',this.handleScroll)
        }

    }
    // handleBox(){
    //     console.log('handleBox')
    //     this.setState({Box:false})
    // }
    handleCancelBox(){
        // console.log('handleCancelBox')
        this.setState({Box:false})
    }
    handelEmail(){
        this.setState({visible:true,Box:false})
    }
    modal (){
        return(
            <Modal
              visible={this.state.Box}
              onOk={this.handleBox}
              onCancel={this.handleCancelBox}
              bodyStyle={{position:'static',zIndex:'999999999'}}
              footer={null}
              maskClosable={false}
              className={"Modal"}
              
            >
                <div style={{height:'435px'}} className="BBB">
                    <img src={require('../../assets/common/images/huoqubaojia.png')} alt=""/>
                    <img style={{position:'relative',left:'188px',top:'-185px',cursor:'pointer'}}onClick={this.handelEmail} src={require('../../assets/common/images/anniu.png')} alt=""/>
                </div>
            </Modal>
        )
    }
    // handleBox_one(){
    //     console.log(this.state.handleBox_two)
    //     if (this.state.userPhone.toString().length!==11) {
    //         this.setState({tip:true})
    //     }else if (this.state.userName.toString().length<1) {
    //         this.setState({tipUser:true})
    //     }
    //     else {
    //         this.setState({handleBox_two:true,visible:false})
    //     }
        
    // }
    // handleBox_two(){
    //     this.setState({visible:false,handleBox_two:false})
    // }
    // handleCancel_two(){
    //     this.setState({visible:false,handleBox_two:false})
    // }
    // renderSevers(){
    //     if (this.state.getQuote.services) {
    //         return this.state.getQuote.services.map((item,index)=>(
    //             <TabPane tab={item.title} key={item.id}></TabPane>
    //         ))
    //     }else {
    //         return  <TabPane tab=" " key=' '></TabPane>
    //     }
        
    // }
    // renderIndustry(){
    //     if (this.state.getQuote.industry) {
    //         return this.state.getQuote.industry.map((item,index)=>(
    //             <TabPane tab={item.title} key={item.id}></TabPane>
    //         ))
    //     }else {
    //         return  <TabPane tab=" " key=' '></TabPane>
    //     }
    // }
    // seversCallback(key){
    //     console.log(key);
    //     this.setState({seversName:key})
    // }
    // industryCallback(key){
    //     console.log(key);
    //     this.setState({industry:key})
    // }
    render() {
        // let rightBtn= document.body.offsetHeight/2 -174;
        if (this.props.data) {
            const meta = {
              title: this.props.optimization.title,
              description: this.props.optimization.description,
              // link: {
              //   rel: {
              //     canonical: 'http://example.com/path/to/sub-page'
              //   }
              // },
              meta: {
                charSet: 'utf-8',
                name: {
                  keywords: this.props.optimization.keywords
                },
              },
              extend: true
            };
            return (
                <DocumentMeta {...meta}>
                    <div>
                        {this.modal()}
                        {/*<Modal
                          title={null}
                          visible={this.state.visible}
                          onOk={this.handleOk}
                          onCancel={this.handleCancel}
                          bodyStyle={{position:'static',zIndex:'999999'}}
                          footer={null}
                          width={775}
                          maskClosable={false}
                        >
                            <div className = "Bg">
                                <div className = "Title">
                                    <p className = "Head">获取报价</p>
                                    <p className = "Subhead">
                                        提交的您的需求我们安排产品经理一对一服务，为您提供专属产品功能清单及相关项目报价或拨打18281829555,，直接咨询！
                                    </p>
                                    <img src = { require('../../assets/common/images/chatu.png') } alt=""/>
                                </div>
                                <div className = "Content">
                                
                                    <p className = "P_Common" style={{paddingTop:'20px',marginBottom:'20px'}}>基础信息</p>
                                    <div className = "Input">
                                        <div className = "Pbox" style={{alignItems:'baseline'}}>
                                            <div>贵姓：</div>
                                            <div style={{width:'168.5px'}}>
                                                <Input style={{width:'100%'}} placeholder="请填写您的称呼" value={this.state.userName} autofocus="autofocus" onBlur={()=>this.state.userName.toString().length<1?this.setState({tipUser:true}):null} onChange={(e)=>{this.setState({userName:e.target.value,tipUser:false});console.log(e.target.value)}} />
                                                {this.state.tipUser?<p style={{width:'100%',fontSize:'10px',color:'red'}}>请输入您的称呼！</p>:null}
                                            </div>
                                        </div>
                                        <div className = "Pbox" style={{alignItems:'baseline'}}>
                                            <div>电话：</div>
                                            <div style={{width:'168.5px'}}>
                                                <Input style={{width:'100%'}} placeholder="请填写您的电话" value={this.state.userPhone} onBlur={()=>{this.state.userPhone.toString().length!==11?this.setState({tip:true}):null}} onChange={(e)=>{this.setState({userPhone:e.target.value,tip:false});console.log(e.target.value)}}/>
                                                {this.state.tip?<p style={{width:'100%',fontSize:'10px',color:'red'}}>手机号码输入错误!</p>:null}
                                            </div>
                                        </div>
                                    </div>
                                    <p className = "P_Common" style={{paddingTop:'20px'}}>服务类型</p>
                                    <div className = "Tabs">
                                        {this.state.getQuote?
                                            <Tabs defaultActiveKey={this.state.seversName} onChange={this.seversCallback}>
                                                {this.renderSevers()}
                                            </Tabs>:null
                                        }
                                    </div>
                                </div>
                                <div className = "Btn" style={{cursor:'pointer',textAlign: 'center',lineHeight: '50px',color: 'white'}} onClick={this.handleBox_one}>
                                    <img src = { require( '../../assets/common/images/xiayibu.png' ) } alt=""/>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                          visible={this.state.handleBox_two}
                          onOk={this.handleBox_two}
                          onCancel={this.handleCancel_two}
                          bodyStyle={{position:'static',zIndex:'99999999999999'}}
                          footer={null}
                          width={775}
                          maskClosable={false}
                        >
                            <div className = "Bg_tw">
                                <div className = "Title">
                                    <p className = "Head">您的需求</p>
                                    <p className = "Subhead">
                                       请根据您的项目需求填写，我们的产品经理会在十分钟内联系您，为您发送专属方案以及方案报价！
                                    </p>
                                    <img src = { require('../../assets/common/images/chatu.png') } alt=""/>
                                </div>
                                <div className = "Content">
                                    <p className = "P_Common" style={{paddingTop:'20px'}}>所属行业：</p>
                                    <div className = "Tab">
                                        {this.state.getQuote?
                                            <Tabs defaultActiveKey={this.state.industry} onChange={this.industryCallback}>
                                                {this.renderIndustry()}
                                            </Tabs>:null
                                        }
                                    </div>
                                    <p className = "P_Common" style={{paddingBottom:'20px'}}>请您简述需求：</p>
                                    <div className  ="TextArea">
                                        <textarea onChange={(e)=>{this.setState({demand:e.target.value});console.log(e.target.value)}} ></textarea>
                                    </div>
                                </div>
                                
                                <div className = "Btn" onClick={this.handleSubmit} style={{cursor:'pointer',textAlign: 'center',lineHeight: '50px',color: 'white'}}>
                                    <img src = { require( '../../assets/common/images/lijihuoqu.png' ) } alt=""/>
                                </div>
                            </div>
                        </Modal>*/}
                        <Banner props={this.props} {...this.props.bannerProps}/>
                        {this.props.data[0].service?<Corporate props={this.props} CorporateCallback={this.CorporateCallback}/>:null} 
                        {this.props.data[0].case?<Case props={this.props} {...this.props.caseProps}/>:null}
                        {this.props.data[0].news?<News props={this.props} {...this.props.newsProps}/>:null}
                        {this.props.data[0].about?<About props={this.props} {...this.props.aboutProps}/>:null}
                        {this.props.data[0].partner? <Partner {...this.props.partnerProps}/>:null}
                        <Footer {...this.props.footerProps}/>
                        <RightBtn props={this.props} data={this.state.visible} callBack={this.goConsulting}/>
                    </div>
                </DocumentMeta>
            )
        }
    } 

}
